import * as React from 'react';

import { localeData } from '../../locales/data';
import { addModifiers, getLanguageCode } from '../../shared/helpers';

import { PaginationResults } from './PaginationResults';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';

interface PaginationProps {
  pageSize?: number;
  numOfResults?: number;
  changePrevPage: () => void;
  changeNextPage: () => void;
  getPaginationNumbers: () => any[];
  page: number;
  changePage: (val: number) => void;
  pages: number;
  changePageSize?: (e: any) => void;
  handleKeyPress?: (e: any) => void;
  pageSizeLimit?: number;
  showPagination?: boolean;
  extraInfo?: {
    msg: string;
    values: any;
  };
}

export const Pagination =
  (ComponentResults: any = PaginationResults) =>
  ({
    pageSize,
    numOfResults,
    changePrevPage,
    changeNextPage,
    getPaginationNumbers,
    page,
    changePage,
    pages,
    extraInfo,
    handleKeyPress,
    pageSizeLimit,
    showPagination = true,
  }: PaginationProps): JSX.Element =>
    (
      <div className="pagination-footer">
        {ComponentResults && (
          <ComponentResults
            pageSize={pageSize}
            numOfResults={numOfResults}
            extraInfo={extraInfo}
            handleKeyPress={handleKeyPress}
            pageSizeLimit={pageSizeLimit}
          />
        )}
        {showPagination && (
          <div className="pagination-footer__buttons-container">
            <button
              data-testid={'pagination-prev-button'}
              onClick={changePrevPage}
              disabled={page === 0 || numOfResults === 0}
              className={addModifiers('pagination-footer__button', ['previous', page === 0 || numOfResults === 0 ? 'disabled' : 'active'])}
            >
              <FormattedMessageHelper tagName="span" id="tablePagination.4" defaultMessage={localeData.en['tablePagination.4']} />
            </button>
            {getPaginationNumbers().map((val: any, index: number) => {
              const pageNum = page + 1;
              let changePageVal = val;
              if (typeof val === 'number') {
                changePageVal = val - 1;
              }
              const changeNumberedPage = () => changePage(changePageVal);
              const isDots = val === '...';
              return val === pageNum ? (
                <button className={addModifiers('pagination-footer__button', ['active'])} key={index}>
                  {val.toLocaleString(getLanguageCode())}
                </button>
              ) : (
                <button
                  key={index}
                  data-testid={`pagination-${index + 1}-button`}
                  onClick={changeNumberedPage}
                  aria-disabled={isDots}
                  className={addModifiers('pagination-footer__button', ['inactive', ...(isDots ? ['dots'] : [])])}
                >
                  {val.toLocaleString(getLanguageCode())}
                </button>
              );
            })}
            <button
              data-testid={'pagination-next-button'}
              onClick={changeNextPage}
              disabled={page === pages - 1 || numOfResults === 0}
              className={addModifiers('pagination-footer__button', [
                'next',
                page === pages - 1 || numOfResults === 0 ? 'disabled' : 'active',
              ])}
            >
              <FormattedMessageHelper tagName="span" id="tablePagination.5" defaultMessage={localeData.en['tablePagination.5']} />
            </button>
          </div>
        )}
      </div>
    );
